import React from 'react'
import { IndexLink, Link } from 'react-router'
import './Header.scss'

export const Header = () => (
  <div>
    <h1>React Redux Starter Kit</h1>
    <IndexLink to='/' activeClassName='route--active'>
      Home
    </IndexLink>
    {' · '}
    <Link to='/counter' activeClassName='route--active'>
      Counter
    </Link>
    {' · '}
    <Link to='/table' activeClassName='route--active'>
      Table
    </Link>
    {' · '}
    <a href="/dropdown">Dropdown</a>
  </div>
)

export default Header



// WEBPACK FOOTER //
// ./src/components/Header/Header.js